import { Modal } from 'antd';
import { AnimatePresence } from 'framer-motion';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { GO_TO_SETTINGS } from '../../routes/paths';

export const RightPanel = (): JSX.Element => {
    const [isVisible, setIsVisible] = useState(false);

    const toggleInfoModal = () => {
        setIsVisible(!isVisible);
    };

    return (
        <div
            className="relative rounded-16"
            style={{
                width: '25%',
                background: 'linear-gradient(169deg, #D1EDE1 1.86%, #F4F4F4 26.72%)',
            }}
        >
            <div className="absolute inset-0 overflow-y-scroll space-y-24 p-20">
                <div>
                    <svg
                        className="w-24 h-24"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <g clip-path="url(#clip0_2_4510)">
                            <mask
                                id="mask0_2_4510"
                                style={{ maskType: 'alpha' }}
                                maskUnits="userSpaceOnUse"
                                x="0"
                                y="0"
                                width="24"
                                height="24"
                            >
                                <path
                                    d="M23.3454 12C23.3454 18.2659 18.2659 23.3454 12 23.3454C5.73406 23.3454 0.654541 18.2659 0.654541 12C0.654541 5.73406 5.73406 0.654541 12 0.654541C18.2659 0.654541 23.3454 5.73406 23.3454 12Z"
                                    fill="white"
                                />
                            </mask>
                            <g mask="url(#mask0_2_4510)">
                                <path
                                    d="M26.1819 13.4182C26.1819 19.6841 21.1024 24.7636 14.8364 24.7636C8.57049 24.7636 3.49097 19.6841 3.49097 13.4182C3.49097 7.15225 8.57049 2.07272 14.8364 2.07272C21.1024 2.07272 26.1819 7.15225 26.1819 13.4182Z"
                                    fill="#75CAA6"
                                />
                            </g>
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M12 1.80636C6.3702 1.80636 1.80636 6.3702 1.80636 12C1.80636 17.6298 6.3702 22.1936 12 22.1936C16.5739 22.1936 20.4456 19.1807 21.7359 15.03C21.9091 14.4682 21.9657 14.0871 21.9579 13.8421C21.9541 13.7229 21.9356 13.6543 21.9212 13.6195C21.9143 13.6028 21.9087 13.5942 21.9061 13.5908L21.9033 13.5874L21.9016 13.5859C21.9016 13.5859 21.839 13.5395 21.6103 13.5621C21.3897 13.584 21.0966 13.6625 20.7317 13.8001C20.0024 14.0751 19.1199 14.5329 18.1808 15.0215L18.1555 15.0346C17.2428 15.5094 16.2804 16.0101 15.433 16.3381C14.3696 16.7497 13.2687 16.611 12.389 16.1989C11.5236 15.7935 10.7925 15.0839 10.5339 14.2523L10.5304 14.2411L10.5274 14.2298C10.4791 14.0491 10.4331 13.8797 10.3886 13.7215C10.1223 13.6928 9.84505 13.6293 9.55799 13.5295L9.53882 13.5229L9.5202 13.5149C9.23069 13.3908 8.7671 13.1493 8.5061 12.7749C8.36084 12.5664 8.2503 12.2736 8.32907 11.936C8.40386 11.6153 8.62396 11.3679 8.88412 11.1779L8.91315 11.1567L8.94464 11.1393C9.2687 10.9597 9.6394 10.8604 10.02 10.9732C10.3895 11.0827 10.6407 11.3556 10.8159 11.6312C10.9657 11.8669 11.0965 12.1651 11.2173 12.5055C11.2411 12.4972 11.2643 12.4883 11.2869 12.479C11.6171 12.3421 11.8982 12.073 12.1212 11.6925C12.4927 11.0586 12.6472 10.2072 12.6115 9.50358H9.51159C9.1935 9.50358 8.93566 9.24574 8.93566 8.92765C8.93566 8.6096 9.1935 8.35176 9.51159 8.35176H12.3274C12.2145 8.12004 12.0742 7.92374 11.9163 7.77564H9.19753C8.87944 7.77564 8.6216 7.5178 8.6216 7.19971C8.6216 6.88167 8.87944 6.62382 9.19753 6.62382H15.0468C15.3648 6.62382 15.6227 6.88167 15.6227 7.19971C15.6227 7.5178 15.3648 7.77564 15.0468 7.77564H13.3269C13.4218 7.96037 13.5011 8.15407 13.5649 8.35176H15.0469C15.365 8.35176 15.6229 8.6096 15.6229 8.92765C15.6229 9.24574 15.365 9.50358 15.0469 9.50358H13.7642C13.7992 10.4018 13.5994 11.4481 13.115 12.2749C12.8012 12.8103 12.3481 13.286 11.7278 13.543C11.6703 13.5669 11.6119 13.5886 11.5527 13.6081C11.5808 13.7108 11.6088 13.815 11.6369 13.9202C11.7776 14.3583 12.2227 14.849 12.8776 15.1558C13.5233 15.4584 14.2952 15.5434 15.0172 15.2639C15.8007 14.9606 16.7116 14.4873 17.6492 13.9996L17.6671 13.9903C18.5803 13.5153 19.5231 13.0248 20.3253 12.7223C20.7289 12.5701 21.1304 12.4522 21.4967 12.4159C21.855 12.3804 22.272 12.4143 22.6096 12.6773C22.9627 12.9524 23.0953 13.3711 23.1091 13.8055C23.1228 14.235 23.0256 14.7565 22.8363 15.3702C21.4007 19.9892 17.0927 23.3454 12 23.3454C5.73406 23.3454 0.654541 18.2659 0.654541 12C0.654541 5.73406 5.73406 0.654541 12 0.654541C17.5372 0.654541 22.142 4.66399 23.1434 9.90588C23.203 10.2183 22.9816 10.5097 22.6666 10.5535C22.3515 10.5972 22.0623 10.3765 22.0008 10.0645C21.0777 5.37765 16.9476 1.80636 12 1.80636ZM9.95235 12.4468C9.91651 12.3725 9.88048 12.3066 9.84385 12.249C9.75531 12.1098 9.70113 12.0814 9.69284 12.0777C9.67932 12.0769 9.63213 12.0801 9.53479 12.1298C9.51835 12.1427 9.50474 12.1543 9.49344 12.1645C9.52544 12.1958 9.57276 12.2349 9.63894 12.2788C9.73415 12.3419 9.84478 12.3995 9.95235 12.4468Z"
                                fill="#1A1A1A"
                            />
                        </g>
                        <defs>
                            <clipPath id="clip0_2_4510">
                                <rect width="24" height="24" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                </div>

                <div className="space-y-6">
                    <p className="text-16 font-700 text-darwin-neutral_new-800">
                        What are Eka Credits?
                    </p>
                    <p className="text-13" style={{ color: '#1A1A1A' }}>
                        Eka introduces Eka Credits, a virtual currency designed to enhance your
                        experience with our services. Currently, these credits can be used for
                        messaging services.
                    </p>
                </div>

                <div className="space-y-6">
                    <p className="text-16 font-700 text-darwin-neutral_new-800">
                        How Eka Credit utilisation works?
                    </p>
                    <p className="text-13" style={{ color: '#1A1A1A' }}>
                        While WhatsApp’s standard rate is{' '}
                        <span className="font-700">₹0.84 per message,</span> we offer a special rate
                        of <span className="font-700">just ₹0.66 per message</span> to our valued
                        users. This means Eka generously covers the remaining{' '}
                        <span className="font-700">₹0.18</span> for each message you send.
                    </p>
                </div>

                <div className="border border-darwin-green-primary bg-darwin-green-bg-light rounded-8 p-12 space-y-10">
                    <div className="flex items-center space-x-4">
                        <svg
                            className="w-14 h-14 fill-darwin-green-primary"
                            viewBox="0 0 14 14"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path d="M7 13.625C4.66406 13.625 2.53125 12.4062 1.36328 10.375C0.195312 8.36914 0.195312 5.90625 1.36328 3.875C2.53125 1.86914 4.66406 0.625 7 0.625C9.31055 0.625 11.4434 1.86914 12.6113 3.875C13.7793 5.90625 13.7793 8.36914 12.6113 10.375C11.4434 12.4062 9.31055 13.625 7 13.625ZM5.98438 9.15625C5.62891 9.15625 5.375 9.43555 5.375 9.76562C5.375 10.1211 5.62891 10.375 5.98438 10.375H8.01562C8.3457 10.375 8.625 10.1211 8.625 9.76562C8.625 9.43555 8.3457 9.15625 8.01562 9.15625H7.8125V6.92188C7.8125 6.5918 7.5332 6.3125 7.20312 6.3125H5.98438C5.62891 6.3125 5.375 6.5918 5.375 6.92188C5.375 7.27734 5.62891 7.53125 5.98438 7.53125H6.59375V9.15625H5.98438ZM7 3.875C6.54297 3.875 6.1875 4.25586 6.1875 4.6875C6.1875 5.14453 6.54297 5.5 7 5.5C7.43164 5.5 7.8125 5.14453 7.8125 4.6875C7.8125 4.25586 7.43164 3.875 7 3.875Z" />
                        </svg>

                        <p className="text-13 uppercase" style={{ color: '#1A1A1A' }}>
                            Usage per message
                        </p>
                    </div>

                    <div className="space-y-6">
                        <div className="flex items-center justify-between">
                            <p className="uppercase">Whatsapp</p>
                            <p className="font-700">0.66</p>
                        </div>
                        <div className="flex items-center justify-between">
                            <p className="uppercase">SMS</p>
                            <p className="font-700">0.14</p>
                        </div>
                    </div>
                </div>

                <button
                    className="text-darwin-accent-bright-blue-800 font-700"
                    onClick={toggleInfoModal}
                >
                    View list of messages Eka sends
                </button>

                <div className="space-y-6">
                    <p className="text-16 font-700 text-darwin-neutral_new-800">
                        Why am I suddenly being charged Eka Credits?
                    </p>
                    <p className="text-13" style={{ color: '#1A1A1A' }}>
                        Eka Credits have been introduced to offer more specialised services in a
                        pay-per-use model. This approach allows us to enhance these specific
                        features while keeping the overall costs transparent and fair.
                    </p>
                </div>

                <div className="space-y-6">
                    <p className="text-16 font-700 text-darwin-neutral_new-800">
                        I have already paid for Eka’s annual subscription plan. Why am I being
                        charged for credits again?
                    </p>
                    <p className="text-13" style={{ color: '#1A1A1A' }}>
                        Your Eka subscription covers our core services. Eka Credits are for extra
                        features like messaging, giving you flexibility to use and pay for these
                        services as needed. This separate charge ensures that we can maintain
                        high-quality services while offering competitive rates. We also subsidise
                        part of the messaging cost, offering you a lower rate.
                    </p>
                </div>

                <div className="space-y-6">
                    <p className="text-16 font-700 text-darwin-neutral_new-800">
                        How long will my 200 credits last?
                    </p>
                    <p className="text-13" style={{ color: '#1A1A1A' }}>
                        Your 200 Eka Credits will last based on your usage. For each prescription
                        (Rx) you issue, we charge only 0.66 credits. Assuming an average OPD volume
                        of 10 patients per day, the total daily charge would be just Rs. 6. With
                        this usage pattern, your 200 credits can comfortably last for about 2
                        months, offering you ample coverage for your daily operations without
                        frequent top-ups.
                    </p>
                </div>

                <div className="space-y-6">
                    <p className="text-16 font-700 text-darwin-neutral_new-800">
                        Do Eka Credits have an expiration date? How long are they valid for once
                        purchased?
                    </p>
                    <p className="text-13" style={{ color: '#1A1A1A' }}>
                        Eka Credits do not have an expiration date and are valid for as long as your
                        subscription is active. However, please note that if your subscription
                        lapses, your credits will expire too. This ensures you can use your credits
                        freely without concern for time limits, as long as your subscription remains
                        active.
                    </p>
                </div>

                <div className="space-y-6">
                    <p className="text-16 font-700 text-darwin-neutral_new-800">
                        How do I purchase Eka Credits?
                    </p>
                    <p className="text-13" style={{ color: '#1A1A1A' }}>
                        You can purchase Eka Credits in packs of 200, 500, or 1000, with each credit
                        valued at 1 rupee. Simply select a pack based on your needs and pay Rs. 200,
                        Rs. 500, or Rs. 1000 accordingly. This system allows you to select the
                        amount that best suits your practice’s scale and frequency of use.
                    </p>
                </div>

                <AnimatePresence>
                    <InfoModal isVisible={isVisible} toggleInfoModal={toggleInfoModal} />
                </AnimatePresence>
            </div>
        </div>
    );
};

const list = [
    {
        type: 'Appointment Reminder',
        wa: '0.66',
        sms: '-',
        pn: true,
    },
    {
        type: 'Bulk Review',
        wa: '0.66',
        sms: '-',
        pn: true,
    },
    {
        type: 'Single Review',
        wa: '0.66',
        sms: '-',
        pn: true,
    },
    {
        type: 'Follow up reminder',
        wa: '0.66',
        sms: '-',
        pn: true,
    },
    {
        type: 'Send Receipt',
        wa: '0.66',
        sms: '-',
        pn: true,
    },
    {
        type: 'Cancel Appointment',
        wa: '0.66',
        sms: '0.14',
        pn: true,
    },
    {
        type: 'Reschedule Appointment',
        wa: '0.66',
        sms: '0.14',
        pn: true,
    },
    {
        type: 'Post/After Appointment',
        wa: '0.66',
        sms: '0.14',
        pn: true,
    },
    {
        type: 'Self Assessment',
        wa: '0.66',
        sms: '-',
        pn: true,
    },
    {
        type: 'Health Pass',
        wa: '0.66',
        sms: '-',
        pn: true,
    },
    {
        type: 'Consent Form',
        wa: '0.66',
        sms: '-',
        pn: true,
    },
    {
        type: 'Medical Certificates',
        wa: '0.66',
        sms: '-',
        pn: true,
    },
    {
        type: 'Request Vitals',
        wa: '0.66',
        sms: '-',
        pn: true,
    },
    {
        type: 'Prescriptions',
        wa: '0.66',
        sms: '-',
        pn: true,
    },
    {
        type: 'Patient welcome message',
        wa: '-',
        sms: '0.14',
        pn: true,
    },
    {
        type: 'Self Assessment',
        wa: '0.66',
        sms: '-',
        pn: true,
    },
    {
        type: 'Attachments',
        wa: '-',
        sms: '0.14',
        pn: true,
    },
    {
        type: 'Broadcast Messages',
        wa: '-',
        sms: '0.14',
        pn: true,
    },
];

export const InfoModal: React.FC<{ isVisible: boolean; toggleInfoModal: () => void }> = ({
    isVisible,
    toggleInfoModal,
}): JSX.Element => {
    const history = useHistory();

    const goToMessageConfiguration = (): void => {
        history.push(GO_TO_SETTINGS('messageConfiguration'));
    };

    return (
        <Modal
            onCancel={toggleInfoModal}
            width={650}
            closable={false}
            visible={isVisible}
            destroyOnClose
            footer={null}
            bodyStyle={{
                padding: '0px',
                borderRadius: '8px !important',
                height: '500px',
                display: 'flex',
                flexDirection: 'column',
            }}
            className="overflow-hidden rounded-8"
            style={{ height: '500px' }}
        >
            <div className="h-full w-full flex flex-col">
                <div className="flex items-center justify-between px-16 py-12">
                    <p className="text-20 font-700">List of Messages Eka sends</p>
                    <p className="pr-4" onClick={toggleInfoModal}>
                        <svg
                            className="w-14 h-14"
                            viewBox="0 0 12 12"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M10.75 9.71875C11.0312 10.0312 11.0312 10.5 10.75 10.7812C10.4375 11.0938 9.96875 11.0938 9.6875 10.7812L6 7.0625L2.28125 10.7812C1.96875 11.0938 1.5 11.0938 1.21875 10.7812C0.90625 10.5 0.90625 10.0312 1.21875 9.71875L4.9375 6L1.21875 2.28125C0.90625 1.96875 0.90625 1.5 1.21875 1.21875C1.5 0.90625 1.96875 0.90625 2.25 1.21875L6 4.96875L9.71875 1.25C10 0.9375 10.4688 0.9375 10.75 1.25C11.0625 1.53125 11.0625 2 10.75 2.3125L7.03125 6L10.75 9.71875Z"
                                fill="#1A1A1A"
                            />
                        </svg>
                    </p>
                </div>

                <div className="p-16 flex-1 border-t border-b border-darwin-neutral_new-200 space-y-8 overflow-scroll">
                    <p style={{ color: '#1A1A1A' }}>
                        Here is the list of messages Eka sends to your patients along with their Eka
                        Credit cost.
                    </p>
                    <div className="flex items-center space-x-6">
                        <p className="font-700 whitespace-nowrap border border border-darwin-green-primary bg-darwin-green-bg-light text-darwin-green-primary rounded-8 px-8 py-2">
                            Pro Tip
                        </p>
                        <div className="flex items-center space-x-5">
                            <p>Your Patients on</p>
                            <p>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    className="w-16 h-16 m-auto cursor-pointer fill-darwin-accent-bright-blue-800"
                                >
                                    <path d="M22,7a4.34,4.34,0,0,1-1.26,2.81L13.3,17.27a5.46,5.46,0,0,1-.64.53,4.33,4.33,0,0,1-6.72-4h0A1.45,1.45,0,1,1,8.36,15,2,2,0,0,0,11,16.1h0l.19-.08a2.59,2.59,0,0,0,.5-.37L15.33,12,11.67,8.29a2,2,0,0,0-2.83,0,1.91,1.91,0,0,0-.53.91,1.45,1.45,0,0,1-1.75,2.32,1.51,1.51,0,0,1-.57-1A4.32,4.32,0,0,1,13.3,6.69L17,10.33,19.1,8.22a2,2,0,0,0,.07-2.78,9.7,9.7,0,1,0-.67,13.7h0c.23-.21.45-.43.66-.65a2,2,0,0,0-.07-2.78l-1.55-1.55,1.63-1.63,1.55,1.55a4.31,4.31,0,0,1,.15,6,12,12,0,1,1-.8-17c.27.26.54.53.8.81A4.27,4.27,0,0,1,22,7Z" />
                                </svg>
                            </p>
                            <p>
                                eka app gets{' '}
                                <span className="font-700">
                                    Notifications Delivered to app for FREE.
                                </span>
                            </p>
                        </div>
                    </div>
                    <div className="border border-darwin-neutral_new-200 rounded-8 overflow-hidden">
                        <div className="grid grid-cols-12 p-8 bg-darwin-neutrals-50 font-700">
                            <p className="uppercase col-span-6">Message type</p>
                            <p className="uppercase col-span-2 flex items-center justify-center space-x-5">
                                <span>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        className="w-16 h-16 m-auto cursor-pointer fill-darwin-accent-bright-blue-800"
                                    >
                                        <path d="M22,7a4.34,4.34,0,0,1-1.26,2.81L13.3,17.27a5.46,5.46,0,0,1-.64.53,4.33,4.33,0,0,1-6.72-4h0A1.45,1.45,0,1,1,8.36,15,2,2,0,0,0,11,16.1h0l.19-.08a2.59,2.59,0,0,0,.5-.37L15.33,12,11.67,8.29a2,2,0,0,0-2.83,0,1.91,1.91,0,0,0-.53.91,1.45,1.45,0,0,1-1.75,2.32,1.51,1.51,0,0,1-.57-1A4.32,4.32,0,0,1,13.3,6.69L17,10.33,19.1,8.22a2,2,0,0,0,.07-2.78,9.7,9.7,0,1,0-.67,13.7h0c.23-.21.45-.43.66-.65a2,2,0,0,0-.07-2.78l-1.55-1.55,1.63-1.63,1.55,1.55a4.31,4.31,0,0,1,.15,6,12,12,0,1,1-.8-17c.27.26.54.53.8.81A4.27,4.27,0,0,1,22,7Z" />
                                    </svg>
                                </span>
                                <span>Eka App</span>
                            </p>
                            <p className="uppercase col-span-2 text-center">SMS</p>
                            <p className="uppercase col-span-2 text-center">Whatsapp</p>
                        </div>

                        {list.map(({ type, wa, sms, pn }, index) => (
                            <div
                                className={`grid grid-cols-12 p-8 ${
                                    index + 1 !== list.length
                                        ? 'border-b border-darwin-neutral_new-200'
                                        : ''
                                }`}
                            >
                                <p className="col-span-6">{type}</p>
                                <p className="col-span-2 text-darwin-green-primary text-center">
                                    {pn ? 'Free' : '-'}
                                </p>
                                <p className="col-span-2 text-center" style={{ color: '#1A1A1A' }}>
                                    {sms}
                                </p>
                                <p className="col-span-2 text-center" style={{ color: '#1A1A1A' }}>
                                    {wa}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="flex items-center justify-between px-16 py-12">
                    <button
                        className="px-11 py-9 border border-darwin-accent-bright-blue-800 text-darwin-accent-bright-blue-800 font-700 rounded-8"
                        onClick={goToMessageConfiguration}
                    >
                        Message configuration
                    </button>
                    <button
                        className="px-12 py-10 bg-darwin-accent-bright-blue-800 text-white font-700 rounded-8"
                        onClick={toggleInfoModal}
                    >
                        Close
                    </button>
                </div>
            </div>
        </Modal>
    );
};
